import { useEffect, useMemo, useState } from 'react'
import { useAvailableCoinsQuery } from '../../../../core/services/react-query/useAvailableCoinsQuery'
import { useDepositMutation } from '../../../../core/services/react-query/useWalletQuery'
import { useCopyToClipboard } from '../../utils/useCopyToClipboard'
import Select from '../../utils/Select'
import { ClipLoader } from 'react-spinners'
import QRCode from 'react-qr-code'
import CopyIcon from '../../../../components/icons/CopyIcon'
import FeeContainer from '../../utils/FeeContainer'
import { getMainTheme, Text, useWindowSize } from '../../../../modules/Dashboard'
import MobileModal from '../../../../components/layouts/MobileModal'
import { MOBILE_SIZE } from '../../../../core/constants/common'
import { useLocation, useSearchParams } from 'react-router-dom'

export default function NewDepositCoin() {
	const [searchParam,] = useSearchParams()
	const location = useLocation()
	const { width } = useWindowSize()
	const [networks, setNetworks] = useState([])
	const [coin, setCoin] = useState('')
	const [network, setNetwork] = useState('')
	const [modal, setModal] = useState(false)

	const { data: availableCoins } = useAvailableCoinsQuery()

	useEffect(() => {
		if (!!availableCoins && !!coin) {
			const c = availableCoins?.data?.find((x) => x.id === coin.id)
			setNetworks(c?.depositList || [])
			setNetwork('')
		}
	}, [coin, availableCoins])


	useEffect(() => {
		let coinId = searchParam.get('coin')
		if (coinId) {
			const c = availableCoins?.data?.find((x) => x.id === coinId)
			if (c) setCoin(c)
		}
	}, [searchParam, availableCoins])

	const {
		data: depositData,
		mutate: deposit,
		isLoading,
	} = useDepositMutation()

	useEffect(() => {
		if (!!network) {
			let payloadNetwork = network?.network
			if (payloadNetwork === 'erc20') payloadNetwork = 'eth'
			else if (payloadNetwork === 'trc20') payloadNetwork = 'trx'
			else if (payloadNetwork === 'bep20') payloadNetwork = 'bsc'

			const payload = { coin: coin.id, network: payloadNetwork }
			deposit(payload)
		}
	}, [network])

	const { copyToClip } = useCopyToClipboard()
	const address = depositData?.data?.data?.address || ''

	const mappedNetworks =
		networks.length === 0
			? networks
			: networks.map((option) => {
				if (option.network === 'eth') return { ...option, network: 'erc20' }
				if (option.network === 'trx') return { ...option, network: 'trc20' }
				if (option.network === 'bsc') return { ...option, network: 'bep20' }
				return option
			})

	const renderQrAndAddress = () => {
		if (isLoading) {
			return (
				<div className="flex items-center justify-center min-h-[200px] w-full">
					<ClipLoader size={24} color={getMainTheme().primaryOrange} />
				</div>
			)
		}

		if (!address) return null

		return (
			<div className="flex flex-col gap-2 justify-center w-full">
				<div className="self-center flex flex-col items-center gap-5 mb-5">
					<QRCode
						bgColor="#1b1e23"
						fgColor="#9F64DF"
						size={183}
						className="rounded-md"
						value={address}
					/>
				</div>

				<div
					className="flex items-center justify-center cursor-pointer gap-2 p-3 bg-[#15181D] rounded-lg md:rounded-none w-full"
					onClick={() => copyToClip(address)}
				>
					<span className="truncate max-w-[375px] !text-primaryOrange">{address}</span>
					<CopyIcon size={20} color='#fc6432 ' />
				</div>
			</div>
		)
	}

	return (
		<>
			<div className="grid grid-cols-1 gap-4 max-w-lg mx-auto">
				<div className="w-full ">
					<div className={'flex flex-col gap-y-8 mt-2'}>
						<div className={'flex flex-col gap-1'}>
							<Text tid={'select-coin'} className={'text-lg text-secondary mx-1'} />
							<Select
								options={availableCoins?.data || []}
								value={coin}
								onChange={setCoin}
								dropdownClass={'min-h-[164px]'}
								placeholder={'select-an-option'}
								className={'w-full h-[42px] flex items-center rounded-lg'}
								isCoin
							/>
						</div>
						<div className={'flex flex-col gap-1'}>
							<Text tid={'network'} className={'text-lg text-secondary mx-1'} />
							<Select
								value={network}
								options={mappedNetworks}
								onChange={setNetwork}
								className={'w-full h-[42px] flex items-center rounded-lg'}
								placeholder={'select-an-option'}
								selector={'network'}
							/>
						</div>
					</div>
				</div>

				{!!network ? (
					<div className="w-full rounded-md">
						{width >= MOBILE_SIZE ? (
							// Desktop: show everything inline
							<>
								{renderQrAndAddress()}
								<div className="pb-10 mt-4">
									<FeeContainer type={'deposit'} network={network} coin={coin} />
								</div>
							</>
						) : (
							// Mobile: show button + FeeContainer outside modal
							<>
								<button
									onClick={() => setModal(true)}
									className="w-full py-3 rounded-lg bg-primaryOrange text-white"
								>
									<Text tid={"next"} />
								</button>

								<div className="pb-10 mt-4">
									<FeeContainer type={'deposit'} network={network} coin={coin} />
								</div>
							</>
						)}
					</div>
				) :
					<div className='flex flex-col items-center justify-center gap-5'>
						{/* <img src={require('../../assets/fake-qr.webp')} width={150} height={150} alt="" className='rounded-xl opacity-50' /> */}
						<Text tid={"choose-to-get-qrcode"} className='!text-primaryOrange font-semibold text-center' />
					</div>
				}
			</div>

			{/* Mobile Modal */}
			<MobileModal isOpen={modal} onClose={() => setModal(false)}>
				{renderQrAndAddress()}
			</MobileModal>
		</>
	)
}
